export default __webpack_public_path__ + "static/media/ire-flag.8a245617.jpg";